import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as qs from 'qs';
import { EcondosQuery } from '../model/query';
import { WhiteLabel } from '../model/white-label';
import { environment } from '@environment';
import { convertBase64ToBlob } from '../../util/convert-base64-to-blob.util';

export type UploadWhiteLabelBase64ImagesDTO = Record<'name' | 'path' | 'base64', string>;

@Injectable({ providedIn: 'root' })
export class WhiteLabelService {
  private endPoint = `${environment.backendUrl}white-labels/`;

  constructor(private http: HttpClient) {}

  get(query: EcondosQuery = {}): Observable<WhiteLabel[]> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get<WhiteLabel[]>(this.endPoint + '6J2usLV9ddSNaEy9V4z3cbp9RrApyaDM5vHrNWkY', { params });
  }

  getWithCount(query: EcondosQuery = {}): Observable<{ whiteLabels: WhiteLabel[]; count: number }> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get<any>(this.endPoint + '6J2usLV9ddSNaEy9V4z3cbp9RrApyaDM5vHrNWkY', { params, observe: 'response' }).pipe(
      map(({ body: whiteLabels, headers }) => ({
        whiteLabels,
        count: parseInt(headers.get('count') || '0', 10)
      }))
    );
  }

  getWhitelabel(whitelabelId: string, query: EcondosQuery = {}): Observable<WhiteLabel> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get<WhiteLabel>(`${this.endPoint}${whitelabelId}`, { params });
  }

  create(newWhiteLabel: WhiteLabel) {
    return this.http.post<{ _id: string }>(this.endPoint, newWhiteLabel);
  }

  update(whiteLabelId: string, updateWhiteLabel: WhiteLabel) {
    return this.http.put<{}>(`${this.endPoint}${whiteLabelId}`, updateWhiteLabel);
  }

  uploadBase64Images(whiteLabelId: WhiteLabel['_id'], base64Images: UploadWhiteLabelBase64ImagesDTO[]): Observable<unknown> {
    if (!base64Images.length) {
      throw new Error('No white label image to upload');
    }

    const formData = new FormData();

    base64Images.forEach(base64Image => {
      const imageToUploadInfo = encodeURIComponent(
        JSON.stringify({
          path: base64Image.path,
          name: base64Image.name
        })
      );

      const imageBlob = convertBase64ToBlob(base64Image.base64, { type: 'image/png' });

      formData.append(imageToUploadInfo, imageBlob, base64Image.name);
    });

    return this.http.post(`${this.endPoint}${whiteLabelId}/images`, formData);
  }
}
